module.exports = __webpack_public_path__ + "static/img/loading.4101c1b8.gif";